import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  lastError: null,
  offDayApplyForEdit: undefined,
  error: null,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const offDayApplySlice = createSlice({
  name: "offDayApply",
  initialState: initialState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },

    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    allOffDayApplyFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },

    // getrequisitonById
    offDayApplyFetched: (state, action) => {
      state.actionsLoading = false;
      state.offDayApplyForEdit = action.payload.offDayApplyForEdit;
      state.error = null;
    },
  },
});
